import type { FaireProductEntity } from "../../entity_types/product";

export const p_jfxp2rg4ey: FaireProductEntity = {
  token: "p_jfxp2rg4ey",
  type: "product",
  name: "\ud83d\udca3Mini Bath Bombs-100% Natural-100 individually wrapped-\ud83d\udca3",
  brandName: "Lizush",
  imageUrl:
    "https://cdn.faire.com/fastly/39fb28f5bdec6d452055b17ab2618283d0733989bd03e52cd303c2ea790a698b.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b66e074b65d4acda4ea8fd133afcfeb5761d5dc4e3fea33f691bef4334bd1ab5/1555020893.jpg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
